import React from 'react'

const NotFound = ({ loading }) =>
  loading ? null : (
    <React.Fragment>
      <h2>Not Found</h2>
      <p>The page you're looking for does not exist.</p>
    </React.Fragment>
  )

export default NotFound
